/**
 * Stałe z formatami daty
 */
export const DATA_CZAS_FORMATY = {
  parse: {
    dateInput: 'DD-MM-YYYY',
    dateTimeSecInput: 'DD-MM-YYYY HH:mm:ss',
    dateTimeInput: 'dd-MM-yyyy hh:mm',
    dateTimeIso: 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
  },
  display: {
    dateInput: 'DD-MM-YYYY HH:mm:ss',
    dateTimeInput: 'dd-MM-yyyy hh:mm',
    monthYearLabel: 'MM-YYYY',
    dateA11yLabel: 'DD-MM-YYYY HH:mm:ss',
    dateTimeLabel: 'DD-MM-YYYY HH:mm',
    monthYearA11yLabel: 'MM-YYYY',
    dayWithDate: 'dddd, DD.MM.YYYY',
  },
};
